<template>
   <div class="container-fluid maps-state bg-light-purple">
      <div class="row content">
         <div class="col-12 main-container">
            <div id="mainContainer" class="content-container">
               <div class="row">
                  <div class="col">
                     <h1 v-text="allMapsPageData.content[0].header" />
                  </div>

                  <div class="col-12 mb-3 mt-2">
                     <div class="card shadow">
                        <div class="card-header p-0">
                           <div id="select-box-container" class="select-box-container">
                              <div id="dropdownContainer" class="dropdowns" />
                              <div ref="searchBox" class="search-box box-hidden">
                                 <div class="form-group mb-0">
                                    <i class="fc_search" />
                                    <input
                                       id="MapsDataInput"
                                       type="text"
                                       class="form-control inpt-box"
                                       aria-describedby="mapsData"
                                       placeholder="Search e.g. India"
                                       @keyup="search"
                                    />
                                 </div>
                              </div>
                              <div ref="dropDownCon" class="dropdown-container">
                                 <div
                                    class="dropdown-menu dropdown-menu-left show"
                                    aria-labelledby="dropdownMenuLink"
                                 >
                                    <div ref="dropDownItemCon" class="drop-down-list-con" />
                                 </div>
                              </div>
                           </div>
                           <div class="search-box-conatainer">
                              <div class="icon-container" @click="toggleSearch">
                                 <i :class="!isSearchBoxToggled ? 'fc_search' : 'fc_close'" />
                              </div>
                           </div>
                        </div>
                        <div class="card-body p-2">
                           <div id="mapContainer" class="map-container">
                              FusionMaps render here
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="row">
                  <div class="col mb-2">
                     <div class="card shadow">
                        <div class="card-body pt-4 pb-4 pl-3 pr-3">
                           <div class="row ">
                              <div class="col-12 col-sm-6 col-md-12 col-xl-8 col-exl-9">
                                 <h4
                                    class="bottom-box-title"
                                    v-text="allMapsPageData.content[1].header"
                                 />
                                 <div
                                    class="long-desc mb-2 mb-xl-0"
                                    v-html="
                                       markedRender(allMapsPageData.content[1].longDescription)
                                    "
                                 />
                              </div>
                              <div
                                 class="col-12 col-sm-6 col-md-12 col-xl-4 col-exl-3 d-flex align-items-center justify-content-center"
                              >
                                 <button
                                    id="custom-map-contact-btn"
                                    class="card-button btn btn-primary-grad"
                                    @click="showFormModal()"
                                 >
                                    <i class="icn-inline mr-1 headset fc_headset_mic" />
                                    <span>{{ allMapsPageData.content[1].ctas[0].header }}</span>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <b-modal
         v-model="isModalVisible"
         modal-class="request-source-form-modal"
         body-class="request-source-form-modal-body"
         :centered="true"
         :hide-footer="true"
      >
         <ContactSales />
      </b-modal>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import metaGenerator from '../../util/meta.js';
import ContactSales from '../../components/elforms/Sales';
import $service from '../../util/service.js';

export default {
   name: 'ViewMaps',
   components: {
      ContactSales,
   },

   data() {
      return {
         mapsContainer: null,
         isSearchBoxToggled: false,
         lastActiveItem: null,
         isModalVisible: false,
         allMapsData: null,
         chartObj: null,
         queue: [],
         isDropDownVisible: false,
         isMobileView: false,
      };
   },

   computed: {
      ...mapState(['allMapsPageData']),
   },

   watch: {
      $mq() {
         this.checkMobileView();
         this.$nextTick(() => {
            this.renderMap();
         });
      },
   },

   asyncData({ store }) {
      return Promise.all([store.dispatch('ALL_MAP_PAGE_DATA_FETCH')]);
   },

   metaInfo() {
      return metaGenerator(this.allMapsPageData);
   },

   beforeRouteUpdate(to, from, next) {
      next();
      this.switchChart(this.getMapAliasName());
   },

   mounted() {
      this.checkMobileView();
      this.appendFilterArrow();

      $service
         .get('/data/maps')
         .then(response => {
            this.allMapsData = response.data;
            this.renderMap();
         })
         .catch(err => {
            // eslint-disable-next-line
            console.log(err);
         });

      window.addEventListener(
         'resultClicked',
         () => {
            this.isDropDownVisible = false;
         },
         false
      );

      window.addEventListener(
         'resize',
         () => {
            this.mapFilterSlider();
         },
         false
      );
   },

   methods: {
      showFormModal() {
         this.isModalVisible = true;
      },

      toggleSearch() {
         if (this.isSearchBoxToggled) {
            this.$refs.searchBox.classList.add('box-hidden');
            this.isSearchBoxToggled = false;

            if (this.isDropDownVisible) this.toggleDropdown();
         } else {
            this.$refs.searchBox.classList.remove('box-hidden');
            this.isSearchBoxToggled = true;
            document.getElementById('MapsDataInput').focus();
            // if dropdown id enabled and searchbar is taking over then close the drop down.
            this.lastActiveItem !== null && (this.lastActiveItem.style.display = 'none');
         }
      },

      toggleDropdown() {
         if (this.isDropDownVisible) {
            this.$refs.dropDownCon.classList.remove('visible');
            setTimeout(() => {
               this.$refs.dropDownCon.style.display = 'none';
            }, 1000);
         } else {
            this.$refs.dropDownCon.style.display = 'block';
            setTimeout(() => {
               this.$refs.dropDownCon.classList.add('visible');
            }, 200);
         }

         this.isDropDownVisible = !this.isDropDownVisible;
      },

      updateBox(arrow) {
         let pointer = arrow + 1;

         while (document.getElementById(`ddContainer${pointer}`) !== null) {
            const oldDom = document.getElementById(`ddContainer${pointer}`);
            oldDom.parentNode.removeChild(oldDom);
            pointer += 1;
         }

         this.mapFilterSlider();
      },

      createSelectBox(className, options, con, arrow, arr) {
         const createAnchor = _class => {
            const item = document.createElement('a');
            item.href = '#';
            if (_class) item.className = _class;

            return item;
         };
         const anchor = createAnchor('btn dropdown-toggle custom-anchor');
         const ddContainer = document.createElement('div');
         const dropDown = document.createElement('div');
         const ddAnchorCon = document.createElement('div');
         const label = document.createElement('span');
         const label2 = document.createElement('span');

         ddAnchorCon.className = 'dropdown-menu-anchor-container';
         ddContainer.className = 'btn-group';
         ddContainer.id = `ddContainer${arrow}`;

         dropDown.className = 'dropdown-menu';
         dropDown['aria-labelledby'] = 'dropdownMenuLink';
         dropDown.id = `dropDown${arrow}`;
         // anchor.innerHTML = 'Select a Map';
         label.innerHTML = 'Select a Map';
         label.className = 'label';
         anchor.appendChild(label);
         anchor.appendChild(label2);

         if (arrow) {
            const arrowElm = document.createElement('i');
            arrowElm.classList.add('fc_keyboard_arrow_right', 'direction-indicator');
            ddContainer.appendChild(arrowElm);
            dropDown.style.marginLeft = '24px';
         }

         if (arrow === 0 && arr && arr.length) {
            con.innerHTML = '';
         }

         ddContainer.appendChild(anchor);
         ddContainer.appendChild(dropDown);
         dropDown.appendChild(ddAnchorCon);
         con.appendChild(ddContainer);

         options.forEach(data => {
            const option = createAnchor('dropdown-item');
            ddAnchorCon.appendChild(option);
            option.innerHTML = data.name;
            if (data.alias) option.href = `/fusionmaps/${data.alias}`;
            else {
               option.removeAttribute('href');
            }
            option.onclick = e => {
               e.preventDefault();

               // anchor.innerHTML = data.name;
               label2.innerHTML = data.name;
               label.classList.add('shift-label');

               dropDown.style.display = 'none';
               anchor.classList.remove('active');

               if (data.members) {
                  this.updateBox(arrow);
                  this.createSelectBox('form-control', data.members, con, arrow + 1);
               } else {
                  const slug = this.getHighphenSeparetdSlug(data.alias);
                  this.$router.push(`/fusionmaps/${slug}`).catch(() => {});

                  this.updateBox(arrow);
               }
            };
         });
         // onclick button
         anchor.onclick = e => {
            e.preventDefault();
            if (this.lastActiveItem === null) {
               this.lastActiveItem = dropDown;
               dropDown.style.display = 'block';
               anchor.classList.add('active');
            } else if (this.lastActiveItem === dropDown) {
               if (this.lastActiveItem.style.display === 'none') {
                  this.lastActiveItem.style.display = 'block';
               } else this.lastActiveItem.style.display = 'none';
            } else {
               this.lastActiveItem.style.display = 'none';
               this.lastActiveItem = dropDown;
               dropDown.style.display = 'block';
               anchor.classList.add('active');
            }
         };

         if (arr && arr.length) {
            const x = arr.pop();
            // anchor.innerHTML = options[x].name;
            label2.innerHTML = options[x].name;
            label.classList.add('shift-label');
            options[x].members &&
               this.createSelectBox('form-control', options[x].members, con, arrow + 1, arr);
         } else if (arrow) {
            // Uttam
            this.mapFilterSlider();

            this.lastActiveItem.style.display = 'none';
            this.lastActiveItem = dropDown;
            dropDown.style.display = 'block';
            anchor.classList.add('active');
         }
      },

      switchChart(alias = null) {
         if (alias) {
            const clone = this.chartObj.clone({ type: alias });
            this.chartObj.dispose();
            this.chartObj = clone.render();
         }
      },

      searcher(str, _arr, res) {
         const arr = _arr || this.allMapsData;
         let result = [];

         for (let i = 0, ii = arr.length; i < ii; i++) {
            const data = arr[i];
            if (data.members) {
               const val = this.searcher(str, data.members, result);
               if (val && val.length) {
                  val.push(i);
                  result = val;
                  return result;
               }
            } else if (data.alias && data.alias === str) {
               res.push(i);
               return res;
            }
         }
         return result;
      },

      search(e) {
         const isArray = what => Object.prototype.toString.call(what) === '[object Array]';
         const str = typeof e === 'string' ? e : e.target.value;
         let result = [];
         const that = this;
         const changeChart = __data => {
            const slug = this.getHighphenSeparetdSlug(__data);
            this.$router.push(`/fusionmaps/${slug}`).catch(() => {});

            const structure = this.searcher(__data);
            this.createSelectBox(
               'form-control',
               this.allMapsData,
               this.mapsContainer,
               0,
               structure
            );
         };

         const getObject = (theObject, _key, value, queCon) => {
            if (isArray(theObject)) {
               for (let i = 0; i < theObject.length; i++) {
                  result = getObject(theObject[i], _key, value);
               }
            } else {
               Object.keys(theObject).forEach(key => {
                  if (key === _key) {
                     if (
                        theObject.alias &&
                        theObject[key].toLowerCase().indexOf(value.toLowerCase()) >= 0
                     ) {
                        result.push({ name: theObject[key], alias: theObject.alias });
                     }
                  }
                  if (theObject[key] instanceof Object || theObject[key] instanceof Array) {
                     result = getObject(theObject[key], _key, value);
                  }
               });
            }

            if (queCon) {
               this.queue.shift();
               that.appendInDropDown(
                  result,
                  this.$refs.dropDownItemCon,
                  changeChart,
                  e.target,
                  this
               );
               if (this.queue[0]) this.queue[0]();
            }

            return result;
         };

         if (str.length >= 3) {
            this.queue.push(getObject.bind(this, this.allMapsData, 'name', str, true));
            if (this.queue.length === 1) this.queue[0]();
            if (!this.isDropDownVisible) {
               this.$refs.dropDownCon.style.display = 'block';
               setTimeout(() => {
                  this.$refs.dropDownCon.classList.add('visible');
               }, 200);
               this.isDropDownVisible = true;
            }
         } else if (str.length === 0) {
            if (this.isDropDownVisible) this.toggleDropdown();
         }
      },

      appendInDropDown: (data, p, cb, pp) => {
         while (p.firstChild) {
            p.removeChild(p.firstChild);
         }
         if (data.length > 0) {
            data.forEach(elm => {
               const item = document.createElement('a');
               item.className = 'dropdown-item';
               item.href = '#';
               p.appendChild(item);
               item.onclick = e => {
                  e.preventDefault();
                  if (cb) cb(elm.alias);
                  window.dispatchEvent(new Event('resultClicked'));

                  p.parentNode.parentNode.classList.remove('visible');
                  setTimeout(() => {
                     p.parentNode.parentNode.style.display = 'none';
                  }, 1000);
                  pp.value = elm.name;
               };
               item.innerHTML = elm.name;
            });
         } else {
            const item = document.createElement('p');
            p.appendChild(item);
            item.innerHTML = 'Nothing Matched !!!';
         }
      },

      renderMap() {
         if (!this.allMapsData) return;
         this.chartObj && this.chartObj.dispose && this.chartObj.dispose();

         const type = this.getMapAliasName();
         const structure = this.searcher(type.split('/').pop());

         this.mapsContainer = document.getElementById('dropdownContainer');
         this.createSelectBox('form-control', this.allMapsData, this.mapsContainer, 0, structure);

         this.mapFilterSlider();
         this.chartObj = new FusionCharts({
            type,
            renderAt: 'mapContainer',
            width: '100%',
            height: '100%',
            dataFormat: 'json',
            dataSource: {
               chart: {
                  theme: 'fusion',
                  showLabels: '1',
                  nullEntityColor: '#29C3BE',
                  showLegend: 0,
                  nullEntityAlpha: '100',
                  baseFontSize: '10',
                  baseFontColor: '#262A33',
                  borderColor: '#e1f9f8',
                  borderAlpha: '100',
                  borderThickness: '0.5',
                  useHoverColor: '1',
                  entityFillHoverColor: '#29C3BE',
                  entityFillHoverAlpha: '40',
               },
            },
         }).render();
      },

      checkMobileView() {
         const val = this.$mq;
         if (val === 'sm' || val === 'xs' || val === 'md') {
            this.isMobileView = true;
         } else {
            this.isMobileView = false;
         }
      },

      getMapAliasName() {
         let alias = 'world';
         if (this.$route.params && this.$route.params.map) {
            const { map } = this.$route.params;
            alias = map.split('-').pop();
         }
         return `maps/${alias}`;
      },

      getHighphenSeparetdSlug(alias) {
         const structure = this.searcher(alias).reverse();
         const orgData = this.allMapsData;
         const result = [];

         const data = (index, mapData = orgData) => {
            for (let a = 0; a < mapData.length; a++) {
               if (a === index) {
                  result.push(mapData[a].alias ? mapData[a].alias : mapData[a].name);
                  if (structure.length > 0) return data(structure.shift(), mapData[a].members);
                  break;
               }
            }

            return result
               .join('-')
               .toLowerCase()
               .replace(/[()]/gi, '')
               .replace(/[\s]/gi, '-');
         };

         return data(structure.shift());
      },

      mapFilterSlider() {
         const dropDownContainer = document.getElementById('dropdownContainer');
         const selectBoxContainer = document.getElementById('select-box-container');
         if (!dropDownContainer || !selectBoxContainer) return;

         const dropDownWidth = dropDownContainer.offsetWidth;
         const containerWidth = selectBoxContainer.offsetWidth;
         const widthDifference = dropDownWidth - containerWidth;
         const arrowLeft = document.getElementById('arrowLeft');
         const arrowRight = document.getElementById('arrowRight');
         arrowRight.style.display = 'none';
         arrowLeft.style.display = 'none';
         dropDownContainer.style.marginLeft = '0px';
         document.getElementById('filterNavigator').className = 'show';
         if (dropDownWidth > containerWidth) {
            arrowLeft.style.display = 'block';
            dropDownContainer.style.marginLeft = `-${widthDifference}px`;
         }
         arrowLeft.onclick = () => {
            const presentPosition = dropDownContainer.offsetLeft;
            this.filterWidth(presentPosition, 'left');
         };

         arrowRight.onclick = () => {
            const presentPosition = dropDownContainer.offsetLeft;
            this.filterWidth(presentPosition, 'right');
         };
      },

      filterWidth(position, arrow) {
         const dropDownWidth = document.querySelector('#dropdownContainer').offsetWidth;
         const containerWidth = document.querySelector('#select-box-container').offsetWidth;
         const arrowLeft = document.getElementById('arrowLeft');
         const arrowRight = document.getElementById('arrowRight');
         if (arrow === 'left') {
            if (position < 0 && dropDownWidth > containerWidth) {
               if (position < -200) {
                  document.querySelector('#dropdownContainer').style.marginLeft = `${position +
                     200}px`;
                  arrowLeft.style.display = 'block';
                  arrowRight.style.display = 'block';
               } else {
                  document.querySelector('#dropdownContainer').style.marginLeft = '0px';
                  arrowLeft.style.display = 'none';
                  arrowRight.style.display = 'block';
               }
            }
         } else if (arrow === 'right') {
            if (dropDownWidth + position > containerWidth) {
               if (position <= 0 && containerWidth < dropDownWidth + position - 200) {
                  document.querySelector('#dropdownContainer').style.marginLeft = `${position -
                     200}px`;
                  arrowLeft.style.display = 'block';
                  arrowRight.style.display = 'block';
               } else {
                  document.querySelector(
                     '#dropdownContainer'
                  ).style.marginLeft = `-${dropDownWidth - containerWidth}px`;
                  arrowLeft.style.display = 'block';
                  arrowRight.style.display = 'none';
               }
            }
         }
      },

      appendFilterArrow() {
         const target = document.getElementById('select-box-container');
         const filterArrowWrapper = document.createElement('div');
         filterArrowWrapper.id = 'filterNavigator';
         const leftArrow = document.createElement('i');
         leftArrow.id = 'arrowLeft';
         leftArrow.className = 'fc_keyboard_arrow_left';
         const rightArrow = document.createElement('i');
         rightArrow.id = 'arrowRight';
         rightArrow.className = 'fc_keyboard_arrow_right';
         filterArrowWrapper.appendChild(leftArrow);
         filterArrowWrapper.appendChild(rightArrow);
         target.appendChild(filterArrowWrapper);
      },
   },
};
</script>

<style lang="scss">
.maps-state {
   overflow: hidden;

   .card {
      .card-header {
         box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
         display: flex;
      }
   }

   .map-container {
      min-height: 300px;
   }

   .select-box-container {
      width: 95%;
      height: 8rem;
      position: relative;
      background: #fff;

      .form-group {
         margin-bottom: 0 !important;
      }

      .dropdowns {
         .btn-group:last-child {
            padding-right: 0;
         }
      }

      .dropdowns,
      .dropdown-container {
         position: absolute;
         top: 0;
         height: 100%;
         left: 0;
         width: auto;
         padding: 18px 25px;
         transition: all ease 0.4s;
         display: flex;
         align-items: center;
      }

      .search-box {
         position: absolute;
         top: 0;
         height: 100%;
         left: 0;
         width: auto;
         padding: 18px 25px;
         // transition: all ease 0.4s;
         display: flex;
         align-items: center;
      }

      .dropdown-container {
         z-index: 50;
         height: 100%;
         top: 7px;
         transition: all ease 1s;
         opacity: 0;

         .dropdown-menu {
            width: 50%;
            margin-left: 4rem;
         }

         &.visible {
            opacity: 1;
            width: 100%;
         }

         &.no-display {
            display: none;
         }

         p {
            padding-left: 20px;
         }
      }

      .dropdowns {
         z-index: 100;
      }

      .drop-down-list-con {
         max-height: 200px;
         overflow-y: scroll;
      }

      .search-box {
         overflow: hidden;
         z-index: 110;
         background: white;
         width: 100%;
         left: 0;

         .form-group {
            width: 100%;
            margin: 0;
            display: flex;
            align-items: center;

            i.fc_search {
               font-size: 14px;
               margin-left: 10px;
            }
         }

         .dropdown-container {
            width: 100%;
         }
      }

      .box-hidden {
         // margin-left: 100%;
         // z-index: 90;
         left: 100%;
         transition: left ease 0.4s;
      }

      .select-box-container {
         min-width: 20%;
         width: 0;
         display: flex;
         align-items: center;
         background: #fff;
      }

      .direction-indicator {
         color: #ccc;
      }

      .inpt-box {
         border: none;
         box-shadow: none;

         &:focus {
            border: none;
            box-shadow: none;
         }
      }
   }

   .search-box-conatainer {
      height: 8rem;
      border-left: 1px solid #efefef;

      text-align: center;
      width: 10%;
      line-height: 8rem;

      position: relative;
      background: white;

      z-index: 120;

      .icon-container {
         // transition: all ease 0.5s;
         cursor: pointer;

         i {
            font-size: 15px;
            // transition: all ease 0.35s;
         }
      }

      &:hover {
         .icon-container {
            i {
               color: #660f0f;
               // font-size: 20px;
               line-height: 20px;
            }
         }
      }
   }

   .custom-anchor {
      min-width: 185px;
      border: 1px solid rgba(62, 57, 107, 0.13);
      box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.01);
      border-radius: 4px;
      height: 42px;

      font-size: 14px;
      color: #434456;
      letter-spacing: 0.2px;
      line-height: 18px;

      &.active {
         border: 1px solid #48b884;
      }
   }

   .btn-group {
      align-items: center;
   }

   .dropdown-menu {
      margin: 1.125rem 0 0;
      .dropdown-menu-anchor-container {
         max-height: 250px;
         overflow-y: auto;
         overflow-x: hidden;
      }
      .dropdown-item {
         border: none;
         font-size: 14px;
         line-height: 18px;
         color: #73748c;
         padding: 0.65rem 4.5rem 0.65rem 1.5rem;

         &:hover {
            background: rgba(105, 87, 218, 0.06);
            font-weight: 600;
         }
      }
   }
   .dropdown-toggle {
      text-align: left;
      padding-right: 36px;
   }
   .dropdown-toggle:after {
      border-top: 0.35em solid #73748c;
      border-right: 0.35em solid transparent;
      border-left: 0.35em solid transparent;
      // margin-left: 3.2125em;
      right: 15px;
      position: absolute;
      top: 1.3em;
   }

   .dropdown-menu:before {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 8px solid #fff;
      top: -8px;
   }

   .dropdown-menu:after {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
   }

   .shift-label {
      top: -9px;
      color: #9f9fb9;
      font-size: 12px;
      letter-spacing: -0.1px;
      line-height: 15px;
   }

   .label {
      position: absolute;
      transition: all ease 0.4s;
      background: #fff;
   }
   .bottom-box-title {
      font-size: 19px;
      font-weight: 600;
      line-height: 26px;
      color: #212344;
      margin-bottom: 10px;
   }

   .long-desc {
      p {
         margin-bottom: 0px;
      }
   }

   .headset {
      font-size: 18px;
   }

   #filterNavigator {
      position: absolute;
      width: 100%;
      top: 29px;
      i {
         position: absolute;
         z-index: 102;
         width: 20px;
         height: 20px;
         background-color: white;
         box-shadow: 0px 4px 9px 0 rgba(23, 28, 33, 0.2);
         line-height: 20px;
         border-radius: 50%;
         font-size: 20px;
         cursor: pointer;
         &.fc_keyboard_arrow_right {
            right: 10px;
         }
         &.fc_keyboard_arrow_left {
            left: 10px;
         }
      }

      &.hide {
         display: none;
      }

      &.show {
         display: block;
      }
   }
}

#select-box-container {
   position: relative;
   &:before {
      content: '';
      width: 35px;
      height: 100%;
      display: block;
      position: absolute;
      z-index: 101;
      left: 0;
      top: 0;
      background: -moz-linear-gradient(
         left,
         rgba(255, 255, 255, 1) 29%,
         rgba(255, 255, 255, 0.42) 70%,
         rgba(255, 255, 255, 0) 100%
      );
      background: -webkit-linear-gradient(
         left,
         rgba(255, 255, 255, 1) 29%,
         rgba(255, 255, 255, 0.42) 70%,
         rgba(255, 255, 255, 0) 100%
      );
      background: linear-gradient(
         to right,
         rgba(255, 255, 255, 1) 29%,
         rgba(255, 255, 255, 0.42) 70%,
         rgba(255, 255, 255, 0) 100%
      );
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=1 );
   }

   &:after {
      content: '';
      width: 35px;
      height: 100%;
      display: block;
      position: absolute;
      z-index: 101;
      right: 0;
      top: 0;
      background: -moz-linear-gradient(
         left,
         rgba(255, 255, 255, 0) 0%,
         rgba(255, 255, 255, 0.42) 30%,
         rgba(255, 255, 255, 1) 71%
      );
      background: -webkit-linear-gradient(
         left,
         rgba(255, 255, 255, 0) 0%,
         rgba(255, 255, 255, 0.42) 30%,
         rgba(255, 255, 255, 1) 71%
      );
      background: linear-gradient(
         to right,
         rgba(255, 255, 255, 0) 0%,
         rgba(255, 255, 255, 0.42) 30%,
         rgba(255, 255, 255, 1) 71%
      );
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=1 );
   }
}
</style>

<style lang="scss" scoped>
@import '../../util';
.content {
   padding: 30px 0;

   @include media-breakpoint-up(sm) {
      padding: 30px;
   }

   @include media-breakpoint-up(md) {
      padding: 50px 30px 30px 30px;
   }

   @include media-breakpoint-up(lg) {
      padding: 50px 30px 50px 30px;
   }
}
</style>
